import React from "react";
import { useState, useEffect } from "react";
import Modal from "./Modal";
import Marquee from "./Marquee";
const HomePage = () => {
  const handlePdfLoad = () => {
    // URL of the PDF file
    const pdfUrl = "/Madura_Gots_Certificate.pdf"; // Update this with your PDF file path
    window.open(pdfUrl, "_blank");
  };
  const handlePdfLoadHigg = () => {
    // URL of the PDF file
    const pdfUrl = "/Higg_Cert.pdf"; // Update this with your PDF file path
    window.open(pdfUrl, "_blank");
  };
  const handlePdfLoadGOTS = () => {
    // URL of the PDF file
    const pdfUrl = "/Madura_Gots_Certificate.pdf"; // Update this with your PDF file path
    window.open(pdfUrl, "_blank");
  };
  const handlePdfLoadOCS = () => {
    // URL of the PDF file
    const pdfUrl = "/OCS_Cert.pdf"; // Update this with your PDF file path
    window.open(pdfUrl, "_blank");
  };
  const handlePdfLoadGRS = () => {
    // URL of the PDF file
    const pdfUrl = "/GRS_Cert.pdf"; // Update this with your PDF file path
    window.open(pdfUrl, "_blank");
  };
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false); // State to control modal visibility
  const [modalContent, setModalContent] = useState("");

  const closeModal = () => {
    setIsModalOpen(false);
    setModalContent({});
  };

  const openModal = (content) => {
    setModalContent(content);
    setIsModalOpen(true);
  };

  const [yearDifference, setYearDifference] = useState(20);
  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const difference = currentYear - 2001;
    setYearDifference(difference);
  }, []);

  // Preload the video in a hidden element
  useEffect(() => {
    const videoPreloader = document.createElement("video");
    videoPreloader.src = "./Website_Banner.mp4"; // ensure this path is correct
    videoPreloader.preload = "auto";
    videoPreloader.oncanplaythrough = () => {
      console.log("Preloaded video can play through.");
      setIsVideoLoaded(true);
    };
    videoPreloader.onerror = (err) => {
      console.error("Error preloading video:", err);
      // Fallback: after a timeout, show the main content
      setTimeout(() => setIsVideoLoaded(true), 5000);
    };
    videoPreloader.load();
  }, []);

  return (
    <div className="pt-20 font-poppins" style={{ overflow: "hidden" }}>
      {/* <div
        className="relative w-full h-[40vh] bg-cover bg-center"
        style={{ backgroundImage: `url('/homeBanner.svg')` }}
      ></div> */}
      {/* Div for small screen start */}
      {/* <div className="block md:hidden relative w-full h-[65vh] md:h-[75vh] overflow-hidden">
        <img
          src="./homeImageNewSmall.png" //homeImage.png replace with the actual path
          alt="Vertically Integrated Infrastructure"
          className="absolute inset-0 w-full h-full object-stretch"
        />
      </div> */}

      <div className="block md:hidden relative w-full h-[65vh] md:h-[75vh] overflow-hidden">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover"
        >
          <source src="./Website_Banner.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center">
          <div
            className="text-white text-3xl md:text-6xl font-bold p-4 pb-2" // Responsive font size for smaller screens
            style={{ fontFamily: "Poppins, sans-serif" }}
          >
            Vertically{" "}
            <span
              style={{
                WebkitTextStroke: "1px white",
                color: "transparent",
              }}
            >
              Integrated
            </span>
          </div>

          <div
            className="text-white text-4xl md:text-6xl font-bold p-4 pt-2" // Responsive font size for smaller screens
            style={{ fontFamily: "Poppins, sans-serif" }}
          >
            Infrastructure
          </div>
        </div>
      </div>

      {/* Div for small screen end */}
      {/* Div for large screen start */}
      {/* <div className=" hidden md:block relative w-full h-[65vh] md:h-[80vh] overflow-hidden">
        <img
          src="./homeImageNew.png" //homeImage.png replace with the actual path
          alt="Vertically Integrated Infrastructure"
          className="absolute inset-0 w-full h-full object-stretch"
        />
      </div> */}

      {/* <div className="hidden md:block relative w-full h-[65vh] md:h-[80vh] overflow-hidden">
        <video autoPlay muted loop className="w-full h-full object-cover">
          <source src="./Website_Banner.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center">
          <div
            className="text-white text-6xl font-bold p-4"
            style={{ fontFamily: "Poppins, sans-serif" }}
          >
            Vertically
          </div>
          <div
            className="text-white text-6xl font-bold p-4"
            style={{ fontFamily: "Poppins, sans-serif" }}
          >
            <span
              style={{
                WebkitTextStroke: "1px white",
                color: "transparent",
              }}
            >
              Integrated
            </span>
          </div>

          <div
            className="text-white text-6xl font-bold p-4"
            style={{ fontFamily: "Poppins, sans-serif" }}
          >
            Infrastructure
          </div>
        </div>
      </div> */}
      <div className="hidden md:block relative w-full h-[65vh] md:h-[80vh] overflow-hidden">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover"
        >
          <source src="./Website_Banner.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center">
          <div
            className="text-white text-6xl font-bold p-4"
            style={{ fontFamily: "Poppins, sans-serif" }}
          >
            Vertically{" "}
            <span
              style={{
                WebkitTextStroke: "1px white",
                color: "transparent",
              }}
            >
              Integrated
            </span>
          </div>

          <div
            className="text-white text-6xl font-bold p-4"
            style={{ fontFamily: "Poppins, sans-serif" }}
          >
            Infrastructure
          </div>
        </div>
      </div>

      {/* Div for large screen end */}
      <div className="flex flex-col md:flex-row w-full gap-4 p-4 ml-0 md:ml-4 md:mt-4 ">
        {/* First Cell */}
        <div className="w-full text-center md:text-left md:w-1/2 flex flex-col items-center justify-center  rounded-lg p-4">
          <div class=" w-auto h-auto">
            <svg>
              <text
                class="text-5xl"
                x="50%"
                y="30%"
                text-anchor="middle"
                font-family="Poppins, sans-serif"
                stroke="black"
                stroke-width="1"
                fill="none"
              >
                MADURA
              </text>
            </svg>
          </div>

          <div class="text-5xl w-full font-extrabold flex items-center justify-center -mt-24 pl-2 pr-2 md:pl-0 md:pr-0">
            MERCERISERS
          </div>
        </div>

        {/* Second Cell with Two Columns */}
        <div className="w-full ">
          {/* First Column */}
          <div className="w-full  rounded p-4">
            <p className="text-gray-700">
              Certified by{" "}
              <span class="font-bold">GOTS, OCS, GRS and Higg</span> we are
              committed to sustainability through the use of organic and
              recycled materials, ethical manufacturing, and transparent
              practices that ensure a positive environmental impact.
            </p>
          </div>

          {/* Second Column */}
          {/* <div className="w-full pl-4">
            <div className="flex flex-row">
              <div className="w-[50%] ">
                <button
                  className="text-xl  underline font-semibold  hover:text-red-500 focus:outline-none"
                  onClick={handlePdfLoad}
                >
                  View Certificate
                </button>
              </div>
              <div className=" w-[50%] flex justify-end mr-12">
                <img
                  src="/gotsLogo.png" //homeImage.png replace with the actual path
                  alt="Vertically Integrated Infrastructure"
                  className=" h-16 object-fit"
                />
              </div>
            </div>
          </div> */}
          {/* Version 1 */}
          <div className="w-full pl-4 ">
            <div className="flex  items-center justify-center  lg:-ml-[15%]   ">
              {/* GOTS */}
              <img
                src="/GOTS_Cert.png"
                alt="GOTS Certificate"
                className="ml-4 lg:ml-6  h-14 md:h-16 lg:h-20 object-contain cursor-pointer flex-shrink-0 hover:scale-105 transition-transform duration-150"
                onClick={handlePdfLoadGOTS}
              />

              {/* OCS */}
              <img
                src="/OCS_Cert.png"
                alt="OCS Certificate"
                className="ml-4  lg:ml-10 h-14 md:h-16 lg:h-20 object-contain cursor-pointer flex-shrink-0 hover:scale-105 transition-transform duration-150"
                onClick={handlePdfLoadOCS}
              />

              {/* GRS */}
              <img
                src="/GRS_Cert.png"
                alt="GRS Certificate"
                className="ml-4 lg:ml-10 h-14 md:h-16 lg:h-20 object-contain cursor-pointer flex-shrink-0 hover:scale-105 transition-transform duration-150"
                onClick={handlePdfLoadGRS}
              />

              {/* HIGG */}
              <img
                src="/Higg_Cert.png"
                alt="Higg Certificate"
                className="ml-2 lg:ml-10 h-14 md:h-16 lg:h-20 object-contain cursor-pointer flex-shrink-0 hover:scale-105 transition-transform duration-150"
                onClick={handlePdfLoadHigg}
              />
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col md:flex-row md:mt-2  pt-4 md:ml-12 md:mr-0 ml-8 mr-8">
        <div class="w-full md:w-[50%]">
          <div class="mt-4 tracking-extra-wide text-red-500" data-nosnippet>
            Who we are?
          </div>
          <div class="mt-4 text-4xl font-extrabold">
            Two decades of Fabric and Garment Legacy
          </div>
          <div class="mt-6 text-lg md:leading-8">
            At Madura Mercerisers, we bring over {yearDifference} years of
            fabric expertise to the forefront of the industry. Our commitment to
            quality and innovation has established us as a leader in
            manufacturing premium knitted fabrics and garments. Specializing in
            advanced fabric processing techniques, we prioritize sustainability
            with cutting-edge facilities, ensuring environmental responsibility.
            With a strong foundation built on craftsmanship and a dedication to
            excellence, we continue to shape the future of textile
            manufacturing, one thread at a time.
          </div>
          {/* <div className="rounded-full border-2 border-black p-2  mt-5">
            Learn More
          </div> */}
          {/* <div className="mt-5 flex">
            <div className="rounded-full border-2 border-black p-3">
              <span>Learn More</span>
            </div>
          </div> */}
        </div>
        <div class="w-full md:w-[50%] pt-8  md:pl-9 md:pr-8 flex justify-center items-center  ">
          <div className="relative w-full md:w-[75%]   md:h-full overflow-hidden">
            <img
              src="./homeWho.jpg" //homeImage.png replace with the actual path
              alt="Vertically Integrated Infrastructure"
              className="md:absolute h-[40vh] inset-0 w-full  md:h-full  object-stretch"
            />
          </div>
        </div>
      </div>

      <div class="md:mt-4">
        <div class="flex flex-col md:flex-row ">
          <div class="w-full md:w-[50%] pl-8 md:pl-16 pt-8 pr-8 md:pr-0">
            <h3 class="mt-4 tracking-extra-wide text-red-500">
              What we offer?
            </h3>
            <h2 class="mt-7 text-4xl font-extrabold md:leading-12">
              Fabric Processing, Ready-to-Cut Fabrics & Garments
            </h2>
          </div>
          <div class=" w-full   md:ml-0 md:mr-0  sm:w-[50%] flex flex-col md:flex-row mt-8 md:mt-20">
            <div class="ml-8 md:ml-12 flex flex-col w-full md:w-[40%] p-2">
              <div class="font-extrabold">Mercerising</div>
              <div class="flex flex-wrap mt-2 mr-4 md:mr-0 w-full   md:w-full  ">
                <div class="flex flex-wrap  pr-4 md:pr-0 mr-4 text-[#6E6D7E]">
                  Mercerizing is a transformative fabric treatment that can
                  significantly enhance the performance.
                </div>
                <button
                  onClick={() =>
                    openModal(
                      <div>
                        {/* Full-width image */}
                        <div
                          className="w-full h-[40vh] bg-cover bg-center rounded-xl"
                          style={{
                            backgroundImage: "url(/Mercerising.png)",
                          }}
                        ></div>

                        {/* Mercerizing Title */}
                        <h2 className="tracking-extra-wide text-red-500 text-left text-xl font-bold my-4">
                          Mercerizing
                        </h2>

                        {/* Description Paragraph */}
                        <p className="text-black px-4">
                          Dornier is a modern tubular Mercerising range imported
                          from Germany. The machine is ideal for the Mercerising
                          of all types of knitted fabrics such as single jersey,
                          inter-lock, fine rib, and pique in cotton or its
                          blends. Not only high-grade fabrics of fine, combed
                          cotton twist but also medium grades in short staple
                          cotton undergo an appreciable boost to their quality
                          as a result of this process. The system featuring its
                          patented power-adjustable circular expanders in the
                          stabilizing, washing, and neutralizing sections,
                          ensures the cost-efficient mercerizing of the tubular
                          knit fabrics for all such garments. The Dornier system
                          guarantees some of the top-level qualities:
                        </p>

                        {/* Bullet Points */}
                        <ul className="list-disc pl-8 my-4">
                          <li>Pill-free surfaces</li>
                          <li>
                            Increased dimensional stability in both length and
                            width
                          </li>
                          <li>
                            Considerably better residual shrinking values than
                            with unmercerised cotton
                          </li>
                          <li>Permanent luster</li>
                          <li>Excellent brilliance and depth of color</li>
                          <li>Silken handle</li>
                          <li>
                            Lower tensile strength loss during high-performance
                            finishing
                          </li>
                          <li>Improved wearing specification properties</li>
                        </ul>

                        {/* Specification Title */}
                        <h3 className="text-black text-center text-xl font-bold my-4">
                          Specification
                        </h3>

                        {/* Specification Table */}
                        <div className="flex flex-col items-center my-4">
                          <div className="overflow-x-auto w-full">
                            <table className="table-auto w-full text-left whitespace-no-wrap">
                              <tbody>
                                <tr className="bg-gray-100">
                                  <td className="p-4">Model</td>
                                  <td className="p-4">EcoMerc 3-S</td>
                                </tr>
                                <tr>
                                  <td className="p-4">Process</td>
                                  <td className="p-4">
                                    Continuous Tubular Mercerising Machine
                                  </td>
                                </tr>
                                <tr className="bg-gray-100">
                                  <td className="p-4">Capacity</td>
                                  <td className="p-4">6 Tons/Day</td>
                                </tr>
                                <tr>
                                  <td className="p-4">Specification</td>
                                  <td className="p-4">
                                    950-1450 Working Width
                                  </td>
                                </tr>
                                <tr className="bg-gray-100">
                                  <td className="p-4">Make</td>
                                  <td className="p-4">Germany</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    )
                  }
                  class="border-2 border-black p-1 mt-2 flex items-center"
                >
                  Learn More
                  <svg
                    class="ml-2 w-4 h-4"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M5 12h14m0 0l-6-6m6 6l-6 6"
                    />
                  </svg>
                </button>
              </div>
            </div>

            <div class="ml-8 md:ml-12 flex flex-col w-full md:w-[40%] p-2">
              <div class="font-extrabold">Stentering</div>
              <div class="flex flex-wrap mt-2 mr-4 md:mr-0 w-full  md:w-full   ">
                <p class="flex flex-wrap mr-4 pr-6 md:pr-0 text-[#6E6D7E]">
                  Stentering is an essential finishing process that helps
                  stabilize fabric dimensions.
                </p>
                <button
                  onClick={() =>
                    openModal(
                      <div className="w-full">
                        {/* Full-width Image */}
                        <div
                          className="w-full h-[40vh] bg-cover bg-center rounded-xl"
                          style={{
                            backgroundImage: "url(/Stentering.png)",
                          }}
                        ></div>

                        {/* Stentering Title */}
                        <h2 className="tracking-extra-wide text-red-500 text-left text-xl font-bold my-4">
                          Stentering
                        </h2>

                        {/* Description Paragraph */}
                        <p className="text-black px-4">
                          Kranz K30 Stenter Machine is a high-performance
                          textile finishing machine designed for heat-setting,
                          drying, and width control of knitted fabrics. It
                          ensures superior fabric quality, dimensional
                          stability, and efficient finishing processes.
                        </p>

                        {/* Key Functions Title */}
                        <h3 className="text-black text-xl font-bold my-4 px-4">
                          Key Functions of Kranz K30 Stenter Machine:
                        </h3>

                        {/* Bullet Points */}
                        <ul className="list-disc pl-8 my-4">
                          <li>
                            Heat-Setting – Fixes fabric structure and
                            properties, preventing shrinkage.
                          </li>
                          <li>
                            Drying – Removes moisture after dyeing or washing
                            processes.
                          </li>
                          <li>
                            Width Control – Maintains uniform fabric width
                            through controlled tension.
                          </li>
                          <li>
                            Chemical Finishing – Facilitates applications like
                            water repellency, softening, and antimicrobial
                            treatments.
                          </li>
                        </ul>

                        {/* Specification Title */}
                        <h3 className="text-black text-left text-xl font-bold my-4">
                          Specification
                        </h3>

                        {/* Specification Table */}
                        <div className="flex flex-col items-center my-4">
                          <div className="overflow-x-auto w-full">
                            <table className="table-auto w-full text-left whitespace-no-wrap">
                              <tbody>
                                <tr className="bg-gray-100">
                                  <td className="p-4">Model</td>
                                  <td className="p-4">Kranz – K30</td>
                                </tr>
                                <tr>
                                  <td className="p-4">Process</td>
                                  <td className="p-4">Stentering</td>
                                </tr>
                                <tr className="bg-gray-100">
                                  <td className="p-4">Capacity</td>
                                  <td className="p-4">10 Tons/Day</td>
                                </tr>
                                <tr>
                                  <td className="p-4">Specification</td>
                                  <td className="p-4">
                                    Working Width from 1200 mm - 2400 mm
                                  </td>
                                </tr>
                                <tr className="bg-gray-100">
                                  <td className="p-4">Make</td>
                                  <td className="p-4">Germany</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    )
                  }
                  class="border-2 border-black p-1 mt-2 flex items-center"
                >
                  Learn More
                  <svg
                    class="ml-2 w-4 h-4"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M5 12h14m0 0l-6-6m6 6l-6 6"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class=" flex flex-wrap md:pt-2 ">
          {/* <div class="w-full sm:w-[50%] flex flex-col md:flex-row"> */}
          <div class="ml-8 md:ml-12 flex flex-col w-full md:w-1/5 p-2  ">
            <div class="font-extrabold">Compacting</div>
            <div class="flex flex-wrap mt-2 mr-4 md:mr-0 w-full  md:w-full  ">
              <p class="flex flex-wrap pr-4 md:pr-0 text-[#6E6D7E]">
                Compacting is a vital finishing process designed to reduce
                fabric shrinkage.
              </p>
              <button
                onClick={() =>
                  openModal(
                    <div
                      className="overflow-hidden"
                      style={{ overflow: "hidden" }}
                    >
                      <div className="flex flex-col ">
                        {/* Full-width image */}
                        <div
                          className="w-full h-[40vh] bg-cover bg-center rounded-xl"
                          style={{
                            backgroundImage: "url(/Compacting.png)",
                          }}
                        />

                        {/* Compacting Section Title */}
                        <h2 className="text-red-600 text-xl font-bold text-center mt-4">
                          Compacting
                        </h2>

                        {/* Description Paragraph */}
                        <p className="text-black px-4 text-center">
                          Tube tex and Ferraro are high-performance textile
                          finishing machines designed to compact and stabilize
                          tubular knitted fabrics. They are essential for
                          achieving high-quality, shrinkage-controlled, and
                          well-finished tubular fabrics, ensuring superior
                          performance in garment production.
                        </p>

                        {/* Tube Tex Tubular Specification Title */}
                        <h3 className="text-black text-lg font-bold mt-4 px-4">
                          Tube Tex Tubular Specification:
                        </h3>

                        {/* Tube Tex Tubular Specification Details in Bulletins */}
                        <ul className="list-disc pl-8 my-4">
                          <li>Model - Tubetex</li>
                          <li>Process - Tubular Compacting</li>
                          <li>Capacity - 8 Tons/Day</li>
                          <li>
                            Specification - Working Width upto 16’’ upto 50’’
                          </li>
                          <li>Make - USA</li>
                        </ul>

                        {/* Ferraro Tubular Specification Title */}
                        <h3 className="text-black text-lg font-bold mt-4 px-4">
                          Ferraro Tubular Specification:
                        </h3>

                        {/* Ferraro Tubular Specification Table */}
                        <div className="overflow-x-auto w-full px-4">
                          <table className="table-auto w-full text-left whitespace-no-wrap">
                            <tbody>
                              <tr className="bg-gray-100">
                                <td className="p-4">Model</td>
                                <td className="p-4">Ferraro</td>
                              </tr>
                              <tr>
                                <td className="p-4">Process</td>
                                <td className="p-4">Tubular Compacting</td>
                              </tr>
                              <tr className="bg-gray-100">
                                <td className="p-4">Capacity</td>
                                <td className="p-4">8 Tons/Day</td>
                              </tr>
                              <tr>
                                <td className="p-4">Specification</td>
                                <td className="p-4">
                                  Working Width from 13’’ upto 49’’
                                </td>
                              </tr>
                              <tr className="bg-gray-100">
                                <td className="p-4">Make</td>
                                <td className="p-4">Italy</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        {/* Open Width Compacting Title */}
                        <h2 className="text-red-600 text-xl font-bold text-center mt-8">
                          Open Width Compacting
                        </h2>

                        {/* Sintec Machine Description */}
                        <p className="text-black px-4 text-center">
                          Sintec Open Width Compacting Machine is an essential
                          solution for textile manufacturers looking to achieve
                          high-quality, pre-shrunk, and well-compacted fabrics
                          for premium garment production.
                        </p>

                        {/* Sintec Machine Functions in Bulletins */}
                        <ul className="list-disc pl-8 my-4">
                          <li>
                            Reduces residual shrinkage for improved fabric
                            stability
                          </li>
                          <li>
                            Enhances fabric softness and surface smoothness
                          </li>
                          <li>
                            Prepares fabric for cutting, sewing, and garment
                            production
                          </li>
                          <li>
                            Ensures uniform width and prevents fabric distortion
                          </li>
                          <li>
                            Increases production efficiency with reduced energy
                            consumption.
                          </li>
                        </ul>

                        {/* Sintec Specification Title */}
                        <h3 className="text-black text-lg font-bold mt-4 px-4">
                          Sintec Open Width Specification:
                        </h3>

                        {/* Sintec Specification Table */}
                        <div className="overflow-x-auto w-full px-4 mb-8">
                          <table className="table-auto w-full text-left whitespace-no-wrap">
                            <tbody>
                              <tr className="bg-gray-100">
                                <td className="p-4">Model</td>
                                <td className="p-4">Sintec – 3 Cylinder</td>
                              </tr>
                              <tr>
                                <td className="p-4">Process</td>
                                <td className="p-4">Open Width Compacting</td>
                              </tr>
                              <tr className="bg-gray-100">
                                <td className="p-4">Capacity</td>
                                <td className="p-4">10 Tons/Day</td>
                              </tr>
                              <tr>
                                <td className="p-4">Specification</td>
                                <td className="p-4">
                                  Working Width from 1200 mm - 2400 mm
                                </td>
                              </tr>
                              <tr className="bg-gray-100">
                                <td className="p-4">Make</td>
                                <td className="p-4">Italy</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  )
                }
                class="border-2 border-black p-1 mt-2 flex items-center"
              >
                Learn More
                <svg
                  class="ml-2 w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 12h14m0 0l-6-6m6 6l-6 6"
                  />
                </svg>
              </button>
            </div>
          </div>
          <div class="ml-8 md:ml-12 flex flex-col w-full md:w-1/5 p-2  ">
            <div class="font-extrabold">Washing</div>
            <div class="flex flex-wrap mt-2 mr-4 md:mr-0 w-full  md:w-full ">
              <p class="flex flex-wrap pr-4 md:pr-0 text-[#6E6D7E]">
                Biowash is an advanced enzyme-based treatment that enhances the
                softness and smoothness of fabrics.
              </p>
              <button
                onClick={() =>
                  openModal(
                    <div className="flex flex-col">
                      {/* Full-width image */}
                      <div
                        className="w-full h-[40vh] bg-cover bg-center"
                        style={{
                          backgroundImage: "url(/Washing.png)",
                        }}
                      />

                      {/* Title "Bio Washing" */}
                      <h2 className="text-red-600 text-xl font-bold text-center mt-4">
                        Bio Washing
                      </h2>

                      {/* Description Paragraph */}
                      <p className="text-black px-4 text-center">
                        Protex The Protex Soft Flow Machine is a specialized
                        textile processing machine used for bio-washing, a
                        sustainable enzymatic treatment that enhances fabric
                        softness, reduces pilling, and improves surface quality.
                        This machine ensures gentle fabric movement, making it
                        ideal for delicate and high-quality textiles.
                      </p>

                      {/* Key Functions Title */}
                      <h3 className="text-black text-lg font-bold mt-4 px-4">
                        Key Functions of Kranz K30 Stenter Machine:
                      </h3>

                      {/* Key Functions List */}
                      <ul className="list-disc pl-8 my-4">
                        <li>Enhanced fabric softness and reduced pilling</li>
                        <li>Improved dye penetration and color brightness</li>
                        <li>
                          Eco-friendly, enzyme-based process with minimal
                          chemical impact
                        </li>
                        <li>
                          Gentle treatment suitable for delicate and premium
                          fabrics
                        </li>
                        <li>Cost-effective with reduced water and energy</li>
                      </ul>

                      {/* Specifications Title */}
                      <h3 className="text-black text-lg font-bold mt-4 px-4">
                        Specification
                      </h3>

                      {/* Specifications Table */}
                      <div className="overflow-x-auto w-full px-4 mb-8">
                        <table className="table-auto w-full text-left whitespace-no-wrap">
                          <tbody>
                            <tr className="bg-gray-100">
                              <td className="p-4">Model</td>
                              <td className="p-4">Protex - 600</td>
                            </tr>
                            <tr>
                              <td className="p-4">Process</td>
                              <td className="p-4">
                                Cold wash, Hot Wash and Bio- wash
                              </td>
                            </tr>
                            <tr className="bg-gray-100">
                              <td className="p-4">Capacity</td>
                              <td className="p-4">10 Tons/Day</td>
                            </tr>
                            <tr>
                              <td className="p-4">Specification</td>
                              <td className="p-4">
                                Working Width from 1200 mm - 2400 mm
                              </td>
                            </tr>
                            <tr className="bg-gray-100">
                              <td className="p-4">Make</td>
                              <td className="p-4">India</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )
                }
                class="border-2 border-black p-1 mt-2 flex items-center"
              >
                Learn More
                <svg
                  class="ml-2 w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 12h14m0 0l-6-6m6 6l-6 6"
                  />
                </svg>
              </button>
            </div>
          </div>{" "}
          <div class="ml-8 md:ml-12 flex flex-col w-full md:w-1/5 p-2  ">
            <div class="font-extrabold">Dryer</div>
            <div class="flex flex-wrap mt-2 mr-4 md:mr-0 w-full  md:w-full">
              <p class="flex flex-wrap pr-4 md:pr-0 text-[#6E6D7E]">
                The drying process is essential for locking in the benefits of
                previous treatments.
              </p>
              <button
                onClick={() =>
                  openModal(
                    <div className="flex flex-col items-center ">
                      {/* Full-width image */}
                      <div
                        className="w-full h-[40vh] bg-cover bg-center rounded-xl"
                        style={{
                          backgroundImage: "url(/Dryer.jpg)",
                        }}
                      ></div>

                      {/* Title "Dryer" */}
                      <div className="text-red-600 text-left text-2xl font-bold  my-4">
                        Dryer
                      </div>

                      {/* Description Paragraph */}
                      <p className="text-black px-4 text-left">
                        Tung Yang machine is designed for Relax Drying knitted
                        fabrics to prevent tension-related shrinkage. Fabric is
                        placed in a relaxed form on a conveyor belt and dried
                        using hot air. Ensures softness and maintains natural
                        elasticity.
                      </p>

                      {/* Specifications Title */}
                      <h3 className="text-black text-xl font-bold mt-4 px-4 text-left">
                        Specification
                      </h3>

                      {/* Specifications Table */}
                      <div className="overflow-x-auto w-full px-4">
                        <table className="table-auto w-full text-left whitespace-no-wrap">
                          <tbody>
                            <tr className="bg-gray-100">
                              <td className="p-4">Model</td>
                              <td className="p-4">Tung Yang</td>
                            </tr>
                            <tr>
                              <td className="p-4">Process</td>
                              <td className="p-4">Relax Dryer</td>
                            </tr>
                            <tr className="bg-gray-100">
                              <td className="p-4">Capacity</td>
                              <td className="p-4">8 Tons/Day</td>
                            </tr>
                            <tr>
                              <td className="p-4">Specification</td>
                              <td className="p-4">
                                Working Width from 1.6 meters – 4 meters
                              </td>
                            </tr>
                            <tr className="bg-gray-100">
                              <td className="p-4">Make</td>
                              <td className="p-4">Taiwan</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )
                }
                class="border-2 border-black p-1 mt-2 flex items-center"
              >
                Learn More
                <svg
                  class="ml-2 w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 12h14m0 0l-6-6m6 6l-6 6"
                  />
                </svg>
              </button>
            </div>
          </div>{" "}
          <div class="ml-8 md:ml-12 flex flex-col w-full md:w-1/5 p-2  ">
            <div class="font-extrabold">Garments</div>
            <div class="flex flex-wrap mt-2 mr-4 md:mr-0 w-full  md:w-full ">
              <p class="flex flex-wrap pr-4 md:pr-0 text-[#6E6D7E]">
                From yarn sourcing to garment, multiple inspections at every
                stage.
              </p>
              <button
                onClick={() =>
                  openModal(
                    <div className="flex flex-col items-center">
                      {/* Full-width image */}
                      <div
                        className="w-full h-[40vh] bg-contain bg-center rounded-xl"
                        style={{ backgroundImage: "url(/Garments.png)" }}
                      />

                      {/* Section Title "Garments" */}
                      <h2 className="text-red-600 text-2xl font-bold text-center mt-4">
                        Garments
                      </h2>

                      {/* Description Paragraph */}
                      <p className="text-black px-4 text-center">
                        House of Madura provides a premium selection of
                        high-quality knitted garments for men and children,
                        crafted from 100% cotton, organic cotton, cotton blends,
                        and fair trade cotton. The range includes garments such
                        as casual wear, sportswear, activewear, sleepwear, and
                        workwear. We provide high-quality clothing products and
                        wholesale services based in India. We deliver fully
                        customized fabric and Garments at low MOQ to independent
                        fashion businesses globally.
                      </p>

                      {/* Product Categories Title */}
                      <h3 className="text-black text-xl font-bold mt-4 px-4">
                        Product Categories
                      </h3>

                      {/* Product Categories List in two columns */}
                      <div className="flex flex-wrap justify-center w-full px-4 mt-2">
                        <ul className="list-disc pl-8 my-4 w-1/2">
                          <li>Tshirt (All fits)</li>
                          <li>Hoodies</li>
                          <li>Sweatshirts</li>
                          <li>Sweatpants</li>
                          <li>Leggings</li>
                          <li>SportsWear</li>
                        </ul>
                        <ul className="list-disc pl-8 my-4 w-1/2">
                          <li>Pants</li>
                          <li>Joggers</li>
                          <li>Shorts</li>
                          <li>Pyjamas</li>
                          <li>Jackets</li>
                          <li>Bibs</li>
                          <li>Rompers</li>
                        </ul>
                      </div>

                      {/* Bold Statement about Innovation */}
                      <p className="text-black font-bold text-center px-4 mt-2">
                        We are constantly innovating and creating new customized
                        garments tailored to your specific requirements.
                      </p>
                    </div>
                  )
                }
                class="border-2 border-black p-1 mt-2 flex items-center"
              >
                Learn More
                <svg
                  class="ml-2 w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 12h14m0 0l-6-6m6 6l-6 6"
                  />
                </svg>
              </button>
            </div>
          </div>
          {/* Render the Modal component */}
          <Modal
            isOpen={isModalOpen}
            onClose={closeModal}
            style={{ overflow: "hidden" }}
          >
            {modalContent} {/* Dynamic content based on the button clicked */}
          </Modal>
        </div>
      </div>
      <div class="flex flex-col md:flex-row pt-4 md:ml-12 ml-8 mr-8 md:mr-0 mb-14 mt-12">
        <div class="w-full md:w-[50%]">
          <div class="mt-4 tracking-extra-wide text-red-500">Why us?</div>
          <div class=" text-3xl font-extrabold mt-4  ">
            Define Modern Manufacturing
          </div>
          <div class="mt-8 text-lg md:leading-8">
            we embody modern manufacturing with over {yearDifference} years of
            expertise in knitted fabric and garment production. Our commitment
            to sustainability is reflected in our advanced facilities, featuring
            Zero Liquid Discharge (ZLD) and efficient water purification
            systems, minimizing environmental impact. We leverage cutting-edge
            fabric processing techniques to ensure quality and durability while
            meeting the evolving needs of our clients. By prioritizing
            innovation, craftsmanship, and responsible sourcing, we shape the
            future of the textile industry, delivering exceptional products that
            exceed expectations.
          </div>
        </div>
        {/* <div class="w-full  md:w-[50%] pt-8  md:pl-9 md:pr-8 ">
          <div className="relative w-full  md:h-full overflow-hidden ">
            <img
              src="./WhyUsImage1.png" //homeImage.png replace with the actual path
              alt="Vertically Integrated Infrastructure"
              className="md:absolute h-[50vh]  inset-0 w-[75%]  md:h-full  object-stretch"
            />
          </div>
        </div> */}
        <div className="w-full md:w-[50%] pt-8 md:pl-9 md:pr-8 flex justify-center items-center">
          {/* <div className="relative w-full h-[50vh] md:h-full overflow-hidden flex justify-center items-center">
            <img
              src="./WhyUsImage1.png" // Replace with the actual path
              alt="Vertically Integrated Infrastructure"
              // className="absolute max-w-full h-auto md:h-full inset-0 m-auto object-scale-down"
              className=" md:absolute h-[40vh] inset-0 w-full  md:h-full  object-stretch"
            />
          </div> */}
          <div className="relative w-full h-[50vh] md:h-[50vh] md:h-full overflow-hidden flex justify-end items-center">
            <video
              src="./MachineVideos.mp4" // Replace with the actual path to your video
              autoPlay
              loop
              muted
              className="md:absolute h-[40vh] inset-0 w-full md:h-full object-stretch"
              alt="All Machines"
            ></video>
          </div>
        </div>
      </div>
      {/* Marquee start */}
      <div class="mt-4 tracking-extra-wide text-red-500 ml-12 mb-2">
        Our Clients
      </div>
      <div class="mt-4 text-3xl font-extrabold ml-12 mb-8">
        Prestigious Partnerships
      </div>
      <div className="ml-14 mr-14 mb-12 mt-12">
        <Marquee></Marquee>
      </div>

      {/* Marquee end */}
    </div>
  );
};

export default HomePage;

// import React, { useState, useEffect } from "react";
// import Modal from "./Modal";
// import Marquee from "./Marquee";

// const HomePage = () => {
//   const [isVideoLoaded, setIsVideoLoaded] = useState(false);
//   const [yearDifference, setYearDifference] = useState(20);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [modalContent, setModalContent] = useState("");

//   // Calculate the year difference
//   useEffect(() => {
//     const currentYear = new Date().getFullYear();
//     const difference = currentYear - 2001;
//     setYearDifference(difference);
//   }, []);

//   // Preload the video in a hidden element
//   useEffect(() => {
//     const videoPreloader = document.createElement("video");
//     videoPreloader.src = "./Website_Banner.mp4"; // ensure this path is correct
//     videoPreloader.preload = "auto";
//     videoPreloader.oncanplaythrough = () => {
//       console.log("Preloaded video can play through.");
//       setIsVideoLoaded(true);
//     };
//     videoPreloader.onerror = (err) => {
//       console.error("Error preloading video:", err);
//       // Fallback: after a timeout, show the main content
//       setTimeout(() => setIsVideoLoaded(true), 5000);
//     };
//     videoPreloader.load();
//   }, []);

//   const handlePdfLoad = () => {
//     const pdfUrl = "/Madura_Gots_Certificate.pdf";
//     window.open(pdfUrl, "_blank");
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setModalContent("");
//   };

//   const openModal = (content) => {
//     setModalContent(content);
//     setIsModalOpen(true);
//   };

//   return (
//     <div className="font-poppins" style={{ overflow: "hidden" }}>
//       {/* Loader Overlay */}
//       {!isVideoLoaded && (
//         <div className="fixed w-full h-screen inset-0 flex items-center justify-center bg-white z-50">
//           {/* Replace with your animated logo drawing */}
//           {/* <img
//             src="/Madura_Icon_PNG.png"
//             alt="Loading Animation"
//             className="w-64 h-32"
//           /> */}
//           <video
//             autoPlay
//             muted
//             loop
//             playsInline
//             className="w-64 h-32 object-cover"
//           >
//             <source src="/IconLoader3.mp4" type="video/mp4" />
//             Loading...
//           </video>
//         </div>
//       )}

//       {/* Main Content: Render only after video preloads */}
//       {isVideoLoaded && (
//         <div className="pt-20">
//           {/* Small Screen Video */}
//           <div className="block md:hidden relative w-full h-[65vh] md:h-[75vh] overflow-hidden">
//             <video
//               autoPlay
//               muted
//               loop
//               playsInline
//               className="w-full h-full object-cover"
//             >
//               <source src="./Website_Banner.mp4" type="video/mp4" />
//               Your browser does not support the video tag.
//             </video>
//             <div className="absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center">
//               <div
//                 className="text-white text-2xl sm:text-4xl md:text-6xl font-bold p-4 pb-2"
//                 style={{ fontFamily: "Poppins, sans-serif" }}
//               >
//                 Vertically{" "}
//                 <span
//                   style={{
//                     WebkitTextStroke: "1px white",
//                     color: "transparent",
//                   }}
//                 >
//                   Integrated
//                 </span>
//               </div>
//               <div
//                 className="text-white text-4xl md:text-6xl font-bold p-4 pt-2"
//                 style={{ fontFamily: "Poppins, sans-serif" }}
//               >
//                 Infrastructure
//               </div>
//             </div>
//           </div>

//           {/* Large Screen Video */}
//           <div className="hidden md:block relative w-full h-[65vh] md:h-[80vh] overflow-hidden">
//             <video
//               autoPlay
//               muted
//               loop
//               playsInline
//               className="w-full h-full object-cover"
//             >
//               <source src="./Website_Banner.mp4" type="video/mp4" />
//               Your browser does not support the video tag.
//             </video>
//             <div className="absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center">
//               <div
//                 className="text-white text-6xl font-bold p-4"
//                 style={{ fontFamily: "Poppins, sans-serif" }}
//               >
//                 Vertically{" "}
//                 <span
//                   style={{
//                     WebkitTextStroke: "1px white",
//                     color: "transparent",
//                   }}
//                 >
//                   Integrated
//                 </span>
//               </div>
//               <div
//                 className="text-white text-6xl font-bold p-4"
//                 style={{ fontFamily: "Poppins, sans-serif" }}
//               >
//                 Infrastructure
//               </div>
//             </div>
//           </div>

//           {/* Other page content */}
//           <div className="flex flex-col md:flex-row w-full gap-4 p-4 ml-0 md:ml-4 md:mt-4">
//             <div className="w-full text-center md:text-left md:w-1/2 flex flex-col items-center justify-center rounded-lg p-4">
//               <div className="w-auto h-auto">
//                 <svg>
//                   <text
//                     className="text-5xl"
//                     x="50%"
//                     y="30%"
//                     textAnchor="middle"
//                     fontFamily="Poppins, sans-serif"
//                     stroke="black"
//                     strokeWidth="1"
//                     fill="none"
//                   >
//                     MADURA
//                   </text>
//                 </svg>
//               </div>
//               <div className="text-5xl w-full font-extrabold flex items-center justify-center -mt-24 pl-2 pr-2 md:pl-0 md:pr-0">
//                 MERCERISERS
//               </div>
//             </div>

//             <div className="w-full ">
//               <div className="w-full rounded p-4">
//                 <p className="text-gray-700">
//                   GOTS certified, dedicated to sustainability by using organic
//                   materials and ethical practices. We deliver high-quality
//                   knitted fabrics while promoting transparency and positive
//                   environmental impact.
//                 </p>
//               </div>
//               <div className="w-full pl-4">
//                 <div className="flex flex-row">
//                   <div className="w-[50%]">
//                     <button
//                       className="text-xl underline font-semibold hover:text-red-500 focus:outline-none"
//                       onClick={handlePdfLoad}
//                     >
//                       View Certificate
//                     </button>
//                   </div>
//                   <div className="w-[50%] flex justify-end mr-12">
//                     <img
//                       src="/gotsLogo.png"
//                       alt="GOTS Logo"
//                       className="h-16 object-fit"
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Add additional content, Modal, Marquee, etc. */}
//           <div className="flex flex-col md:flex-row md:mt-2 pt-4 md:ml-12 md:mr-0 ml-8 mr-8">
//             <div className="w-full md:w-[50%]">
//               <div
//                 className="mt-4 tracking-extra-wide text-red-500"
//                 data-nosnippet
//               >
//                 Who we are?
//               </div>
//               <div className="mt-4 text-4xl font-extrabold">
//                 Two decades of Fabric and Garment Legacy
//               </div>
//               <div className="mt-6 text-lg md:leading-8">
//                 At Madura Mercerisers, we bring over {yearDifference} years of
//                 fabric expertise to the forefront of the industry. Our
//                 commitment to quality and innovation has established us as a
//                 leader in manufacturing premium knitted fabrics and garments.
//               </div>
//             </div>
//             <div className="w-full md:w-[50%] pt-8 md:pl-9 md:pr-8 flex justify-center items-center">
//               <div className="relative w-full md:w-[75%] md:h-full overflow-hidden">
//                 <img
//                   src="./homeWho.jpg"
//                   alt="Who we are"
//                   className="md:absolute h-[40vh] inset-0 w-full md:h-full object-stretch"
//                 />
//               </div>
//             </div>
//           </div>

//           <Modal
//             isOpen={isModalOpen}
//             onClose={closeModal}
//             style={{ overflow: "hidden" }}
//           >
//             {modalContent}
//           </Modal>
//           <Marquee />
//         </div>
//       )}
//     </div>
//   );
// };

// export default HomePage;
